module.exports = __webpack_public_path__ + "img/Display Time Board.81c6dcfc.svg";